import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class CMService {

    headers: Headers;

    constructor(public http: Http) {
        this.headers = new Headers();
    }

    load(url: string): any {
        return new Promise(resolve => {
            this.http.get(url)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                });
        });
    }

    submitComment(url: string, data) {

        return new Promise(resolve => {
            this.http.post(url, data, null)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/cm-service/cm-service.ts